import PropTypes from 'prop-types';
import './viewHeader.scss';

const ViewHeader = ({ header, subHeader, styles, children }) => (
  <section className='vf-view-header-container' style={styles}>
    <h1>{header}</h1>
    {subHeader && (<p>{subHeader}</p>)}
    {children}
  </section>
)

ViewHeader.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.string,
  styles: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

ViewHeader.defaultProps = {
  header: null,
  subHeader: null,
  styles: {},
  children: null,
}

export default ViewHeader;